import GuidedTourBanner from '@/components/AllAccessGuidedTour';
import PausedBanner from '@/components/AllAccessGuidedTour/PausedBanner';
import useGuidedTour from '@/components/AllAccessGuidedTour/useGuidedTour';
import { useSelector } from '@/redux/helper';
import { selectHasGuidedExperienceFeature } from '@/redux/selectors/users';

const TALKING_MASCOT_SRC = 'https://zoolife.tv/assets/guidedTour/mascot/Talking_cropped.png';
const IDLE_MASCOT_SRC = 'https://zoolife.tv/assets/guidedTour/mascot/Idle_cropped.png';
const PAUSED_MASCOT_SRC = 'https://zoolife.tv/assets/guidedTour/mascot/Paused_cropped.png';

const TourBannerSlot = () => {
  const isLoggedIn = useSelector((state) => state.user.logged);
  const hasActiveL1Plan = useSelector(selectHasGuidedExperienceFeature);
  const {
    isActive,
    isPaused,
    currentStep,
    currentStepId,
    handleButtonClick,
    handleGoBack,
    handlePause,
    handleResume,
    handleSkipAhead,
  } = useGuidedTour();

  if (!isLoggedIn || !isActive) return null;

  if (!hasActiveL1Plan) return null;

  if (currentStep?.componentState === 'modal') return null;

  if (isPaused) {
    return (
      <PausedBanner
        currentSection={currentStep?.pausedCurrentSection}
        nextHabitat={currentStep?.pausedNextHabitat}
        mascotSrc={PAUSED_MASCOT_SRC}
        onResume={handleResume}
        onSkipAhead={handleSkipAhead}
      />
    );
  }

  const mascotSrc = currentStep?.componentState === 'idle' ? IDLE_MASCOT_SRC : TALKING_MASCOT_SRC;

  const buttons = (currentStep?.buttons ?? []).map((btn) => ({
    label: btn.label,
    onClick: () => handleButtonClick(btn),
  }));

  const isEnd2 = currentStepId === 'End2';

  return (
    <GuidedTourBanner
      message={currentStep?.speechBubble}
      mascotSrc={mascotSrc}
      buttons={buttons}
      onGoBack={isEnd2 ? undefined : handleGoBack}
      onTakeABreak={isEnd2 ? undefined : handlePause}
    />
  );
};

export default TourBannerSlot;
